import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import formatDuration from "../../utils/formatDuration";

const useStyles = makeStyles(theme => ({
	paper: {
		padding: theme.spacing(2),
		height: "100%",
	},
	empty: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
	},
	rank: {
		fontWeight: 700,
		color: theme.palette.primary.main,
		width: 40,
	},
}));

const AgentsRanking = ({ agents }) => {
	const classes = useStyles();

	return (
		<Paper className={classes.paper}>
			<Typography variant="h6" color="primary" gutterBottom>
				{i18n.t("dashboard.agents.title")}
			</Typography>
			{!agents?.length ? (
				<Typography className={classes.empty}>
					{i18n.t("dashboard.agents.empty")}
				</Typography>
			) : (
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>#</TableCell>
							<TableCell>{i18n.t("dashboard.agents.name")}</TableCell>
							<TableCell align="right">
								{i18n.t("dashboard.agents.closed")}
							</TableCell>
							<TableCell align="right">
								{i18n.t("dashboard.agents.avgTime")}
							</TableCell>
							<TableCell align="right">
								{i18n.t("dashboard.agents.totalTime")}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{agents.map((agent, index) => (
							<TableRow key={agent.userId}>
								<TableCell className={classes.rank}>{index + 1}</TableCell>
								<TableCell>{agent.name}</TableCell>
								<TableCell align="right">{agent.closedCount}</TableCell>
								<TableCell align="right">
									{formatDuration(agent.avgDurationSeconds)}
								</TableCell>
								<TableCell align="right">
									{formatDuration(agent.totalDurationSeconds)}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			)}
		</Paper>
	);
};

export default AgentsRanking;
